import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Button, ButtonMode } from '@components/atoms/Button';
import { Container } from '@components/atoms/Container';
import { Footer } from '@components/molecules/Footer';
import notFound from '@assets/images/404.svg';
import notFoundMobile from '@assets/images/404-mobile.svg';
import styles from './NoInternetPage.module.css';
import { StickyHeader } from '@components/molecules/StickyHeader';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { SITE_URLS } from '@constants';

export const NoInternetPage: FC = () => {
    const { t } = useTranslation();

    const translations = {
        title: t('no-internet-component.message.title'),
        subtitle: t('no-internet-component.message.subtitle'),
        button: t('no-internet-component.message.button'),
        imageAlt: t('no-internet-component.image.alt'),
    };

    const handleRetry = () => {
        window.location.reload();
    };

    return (
        <div className={`page ${styles.noInternetPage}`}>
            <StickyHeader />

            <Container classes="d-flex flex-grow-1 justify-content-center">
                <div className="d-flex flex-row w-100">
                    <div className="left-column d-flex flex-column w-50 p-4 justify-content-center">
                        <img src={notFound} alt={translations.imageAlt} className={`${styles['noInternet-img']} mx-auto`} />
                        <img
                            src={notFoundMobile}
                            alt={translations.imageAlt}
                            className={`${styles['noInternet-img-mobile']} mx-auto`}
                        />
                    </div>
                    <div className="right-column d-flex flex-column justify-content-center w-50">
                        <Typography
                            classes={`${styles.title} lh-sm mb-3`}
                            tagVariant={TypographyTagVariants.h1}
                            color="dark"
                            fontWeight="900"
                            fontSize="14"
                            breakpointsStyles={{ md: { fontSize: '36' } }}>
                            {translations.title}
                        </Typography>
                        <Typography
                            classes={`${styles.subtitle} lh-sm mb-1`}
                            tagVariant={TypographyTagVariants.span}
                            fontWeight="900"
                            fontSize="14"
                            breakpointsStyles={{ md: { fontSize: '18' } }}
                            color="dark">
                            {translations.subtitle}
                        </Typography>
                        <div>
                            <Anchor href={SITE_URLS.home} mode={AnchorMode.secondary} classes="mt-4">
                                {translations.button}
                            </Anchor>
                        </div>
                    </div>
                </div>
            </Container>
            <Footer mode="short" />
        </div>
    );
};
